import { Api, ApiConfig } from '@shared/api';
// import { searchUsers, getPermissionInfo, searchAllUsers, createAuthUser } from '@shared/services'
import { message } from '@tencent/ten-design-react';

export default {
  name: 'UsersModel',
  state: {
    userlist: [],
    userlistpagination: {
      pageSize: 20,
      currentPage: 1,
    },
  },
  reducers: {
    update(prev, data) {
      return { ...prev, ...data };
    },
  },
  effects: {
    async getUserlist(page) {
      try {
        const res = await Api.request(ApiConfig.getAdminUserList, { page });
        this.update({
          userlist: res.rows,
          userlistpagination: {
            currentPage: res.current_page,
            pageSize: res.page_size,
            total: res.total,
          },
        });
      } catch (e) {
        message.error(e.message);
      }
    },
    async getAllUsers({ value, cb }) {
      try {
        const res = await Api.request(ApiConfig.getAllUsersList, { rtx_name_en: value });
        if (cb) cb(res);
      } catch (e) {
        message.error(e.message);
      }
    },
    async addLPAdmin(uid) {
      try {
        await Api.request(ApiConfig.addLPAdmin, { rtx_id: uid });
      } catch (e) {
        message.error(e.message);
      }
      message.success('LP Manager added successfully');
    },
    async deleteLpAdmin(id) {
      try {
        await Api.request(ApiConfig.deleteLpAdmin, { id });
      } catch (e) {
        message.error(e.message);
      }
      message.success('LP Manager deleted successfully');
    },
  },
};
